import $ from "cash-dom"
import noUiSlider from 'nouislider'
import media from '../media.js'


export default class FilterModule {

    static name = 'filter'

    constructor(node) {

        this.activeFilter = []
        this.minDuration = 0;
        this.maxDuration = Infinity;
        this.$filter = $(node)
        this.$range = $('.filter__range')
        this.$list = $(node).next('.foldlist')
        this.$toggle = $('.filter__mobile-toggle')
        this.$close = $('.filter__close')

        this.wasPlayerVisible = true

        //store original count
        this.$list.find('.js-count').each(function() {
            $(this).data('c', this.innerText)
        })

        //this.$range.on('change', this.handleRange)
        this.$filter.on('change', '.filter__checkbox', this.handleCheckbox)
        this.$toggle.on('click', this.handleToggle)
        this.$close.on('click', this.handleClose)

        this.initSlider();
    }

    destroy() {
    }

    initSlider = () => {
        noUiSlider.create(this.$range[0], {

            range: {
                'min': 0,
                'max': 60
            },
            step: 5,
            start: [0, 60],
            tooltips: true,
            connect: true,
            margin: 5,

            format: {
                // 'to' the formatted value. Receives a number.
                to: function(value) {
                    if(value === 60) {
                        return '≥ 60min'
                    } else {
                        return parseInt(value) + 'min'
                    }
                },
                // Receives a string, should return a number.
                from: function(value) {
                    return Number(value.replace('≥', ''))
                }
            },
        })
        .on('update', (values, handle, unencoded) => {

            //set values
            this.minDuration = parseInt(unencoded[0])
            this.maxDuration = unencoded[1] === 60 ? Infinity : parseInt(unencoded[1])

            //highlight dropdown button
            const method = (this.minDuration > 0 || this.maxDuration < Infinity) ? 'addClass' : 'removeClass'
            this.$range.parents('.filter__select')[method]('active')

            this.updateDom()
        })

        mergeTooltips(this.$range[0], 30, ' – ')

    }

    handleCheckbox = (e) => {

        const val = e.target.value

        if(e.target.checked) {
            this.activeFilter.push(val)
        } else {
            const i = this.activeFilter.indexOf(val)
            this.activeFilter.splice(i, 1)
        }

        this.updateDom()
    }
    
    handleToggle = (e) => {
        this.$filter.addClass('visible')
        $('body').addClass('unscrollable')

        //hide player
        if(media.mobilenav.matches) {
            this.wasPlayerVisible = window.player1?.controller_do.isShowed_bl
            window.player1?.hidePlayer()
        }
    }
    
    handleClose = (e) => {
        this.$filter.removeClass('visible')
        $('body').removeClass('unscrollable')

        //show player (if it was previously visible)
        if(this.wasPlayerVisible) {
            window.player1?.showPlayer()
        }
    }
    
    updateDom() {

        //RESET FILTER DROPDOWNS
        this.$filter.find('.filter__select.active')
            .not('.filter__select--range')
            .removeClass('active')

        //RESET CHECKBOXES
        this.$filter.find(`input`).prop('checked', false)

        if(this.activeFilter.length || this.minDuration > 0 || this.maxDuration < Infinity) {

            //SET CHECKBOXES
            this.activeFilter.forEach((val) => {
                this.$filter
                    .find(`input[value="${val}"]`)
                    .prop('checked', true)
                    .parents('.filter__select')
                    .addClass('active')
            })

            let selector = '.comp__item'
            selector += this.activeFilter.map(val => `[data-attr*="${val}"]`).join('')

            //UPDATE LIST
            this.$list.find('.foldable').each((i, element) => {

                const $foldable = $(element)
                const $hits = $foldable.find(selector)

                //manually check durations
                if(this.minDuration > 0 || this.maxDuration < Infinity) {
                    
                    let i = 0;
                    while(i < $hits.length) {
                        const $element = $($hits[i])
                        const d = parseInt($element.data('duration'))

                        //remove hits if they don't match 
                        if(!d || d < this.minDuration || d > this.maxDuration) {
                            $hits.splice(i, 1)
                        } else {
                            i++;
                        }
                    }
                }

                $foldable.find('.comp__item').addClass('inactive')
                $hits.removeClass('inactive')

                if($hits.length) {
                    $foldable.removeClass('inactive')
                } else {
                    $foldable.addClass('inactive')
                }

                $foldable
                    .find('.js-count')
                    .text($hits.length)

            })

            //HIGHLIGHT MOBILE BUTTON
            this.$toggle.addClass('filter__mobile-toggle--highlight')

        } else {

            //RESET LIST
            this.$list
                .find('.js-count')
                .each(function() {
                    $(this).text($(this).data('c'))
                })

            this.$list
                .find('.inactive')
                .removeClass('inactive')

            //RESET MOBILE BUTTON
            this.$toggle.removeClass('filter__mobile-toggle--highlight')
        }
    
    }
}


/**
 * https://refreshless.com/nouislider/examples/#section-merging-tooltips
 * @param slider HtmlElement with an initialized slider
 * @param threshold Minimum proximity (in percentages) to merge tooltips
 * @param separator String joining tooltips
 */
function mergeTooltips(slider, threshold, separator) {

    var textIsRtl = getComputedStyle(slider).direction === 'rtl';
    var isRtl = slider.noUiSlider.options.direction === 'rtl';
    var isVertical = slider.noUiSlider.options.orientation === 'vertical';
    var tooltips = slider.noUiSlider.getTooltips();
    var origins = slider.noUiSlider.getOrigins();

    // Move tooltips into the origin element. The default stylesheet handles this.
    tooltips.forEach(function (tooltip, index) {
        if (tooltip) {
            origins[index].appendChild(tooltip);
        }
    });

    slider.noUiSlider.on('update', function (values, handle, unencoded, tap, positions) {

        var pools = [[]];
        var poolPositions = [[]];
        var poolValues = [[]];
        var atPool = 0;

        // Assign the first tooltip to the first pool, if the tooltip is configured
        if (tooltips[0]) {
            pools[0][0] = 0;
            poolPositions[0][0] = positions[0];
            poolValues[0][0] = values[0];
        }

        for (var i = 1; i < positions.length; i++) {
            if (!tooltips[i] || (positions[i] - positions[i - 1]) > threshold) {
                atPool++;
                pools[atPool] = [];
                poolValues[atPool] = [];
                poolPositions[atPool] = [];
            }

            if (tooltips[i]) {
                pools[atPool].push(i);
                poolValues[atPool].push(values[i]);
                poolPositions[atPool].push(positions[i]);
            }
        }

        pools.forEach(function (pool, poolIndex) {
            var handlesInPool = pool.length;

            for (var j = 0; j < handlesInPool; j++) {
                var handleNumber = pool[j];

                if (j === handlesInPool - 1) {
                    var offset = 0;

                    poolPositions[poolIndex].forEach(function (value) {
                        offset += 1000 - 10 * value;
                    });

                    var direction = isVertical ? 'bottom' : 'right';
                    var last = isRtl ? 0 : handlesInPool - 1;
                    var lastOffset = 1000 - 10 * poolPositions[poolIndex][last];
                    offset = (textIsRtl && !isVertical ? 100 : 0) + (offset / handlesInPool) - lastOffset;

                    // Center this tooltip over the affected handles
                    tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator).replace('min – ', ' – ');
                    tooltips[handleNumber].style.display = 'block';
                    tooltips[handleNumber].style[direction] = offset + '%';
                } else {
                    // Hide this tooltip
                    tooltips[handleNumber].style.display = 'none';
                }
            }
        });
    });
}